import { Injectable } from '@angular/core';
import { HttpClient, HttpEventType,HttpHeaders } from '@angular/common/http';
import { MainService } from './main.service';
@Injectable({
  providedIn: 'root'
})
export class AreaMapService {
  httpUrl;
  constructor(private main:MainService , private http:HttpClient) {
    this.httpUrl = this.main.httpUrl;
   }


  


  async getAreaMapData(obj:any) {
    const resp = await this.http.get<any>(this.main.httpUrl + '/sdp/zone_mapping/getAreaMapData' + JSON.stringify(obj)).toPromise().then(res => {
      return res;
    });
    return resp;
  }

  async areaMaping(obj:any) {
    const resp = await this.http.post<any>(this.main.httpUrl + '/sdp/zone_mapping/areaMaping' , obj).toPromise().then(res => {
      return res;
    });
    return resp;
  }

  async updateAreaMaping(obj:any) {
    const resp = await this.http.post<any>(this.main.httpUrl + '/sdp/zone_mapping/updateAreaMaping' , obj).toPromise().then(res => {
      return res;
    });
    return resp;
  }
  async deleteAreaMaping(obj:any) {
    const resp = await this.http.post<any>(this.main.httpUrl + '/sdp/zone_mapping/deleteAreaMaping' , obj).toPromise().then(res => {
      return res;
    });
    return resp;
  }

}
